import copy from 'copy-to-clipboard';

const copyToClipboard = (rows: any) => {
  let tableContent = '';
  for (const row of rows) {
    const rowString = Object.entries(row)
      ?.map(([key, value]) => `${key}: ${value}`)
      ?.join(', ');
    tableContent += rowString;
    tableContent += '\n';
  }
  copy(tableContent);
};

export default copyToClipboard;
